import { InjectionToken } from '@angular/core';

export interface GitInformation {
  url: string;
}

export const GIT_INFORMATION = new InjectionToken<GitInformation>('', {
  factory: () => ({ url: '' }),
});
